const QUERIES = {
  USERS_LIST: 'users-list',
  BANKS_LIST: 'users-list',
  PAYGROUPS_LIST: 'users-list',
  CATEGORY_LIST: 'users-list',
  JOBTITLES_LIST: 'users-list',
  REGIONS_LIST: 'users-list',
  NATIONALITY_LIST: 'users-list',
  UNITS_LIST: 'users-list',
  NOTCHS_LIST: 'users-list',
  DIVISIONS_LIST: 'users-list',
  COMPANY_LIST: 'users-list',
  CONFIGS_LIST: 'users-list',
  SALARYUPGRADES_LIST: 'users-list',
  GRADES_LIST: 'users-list',
  APPRAISALS_LIST: 'users-list',
  TRAININGS_LIST: 'users-list',
  LEAVES_LIST: 'users-list',
  MEDICALS_LIST: 'users-list',
  RECRUITMENTS_LIST: 'users-list',
  DISCIPLINARYACTIONS_LIST: 'users-list',
  AUDITS_LIST: 'users-list',
  DEPARTMENTS_LIST: 'users-list',
  TAXS_LIST: 'users-list',
  SAVINGSCHEMES_LIST: 'users-list',
  PERIODS_LIST: 'users-list',
  PARAMETERS_LIST: 'users-list',
  OVERTIMES_LIST: 'users-list',
  LOANS_LIST: 'users-list',
  DEDUCTIONS_LIST: 'users-list',
  CURRENCYS_LIST: 'users-list',
  BENEFITS_LIST: 'users-list',
  APPROVALLEVELS_LIST: 'users-list',
  APPROVALS_LIST: 'users-list',
}

export {QUERIES}
